module.exports = __webpack_public_path__ + "img/zfb.4b33b2d7.png";